import React from "react";
import Form, { SimpleItem, GroupItem, ButtonItem } from "devextreme-react/form";
import { useAuth } from "../../context/authContext";

const FilterSelector = ({ formData, handleGetReport }) => {
  const { customerGroups } = useAuth();

  return (
    <div>
      <form onSubmit={handleGetReport}>
        <Form formData={formData}>
          <GroupItem colCount={2}>
            <SimpleItem
              dataField='userGroupIds'
              label={{ text: "Customer group" }}
              editorType='dxTagBox'
              editorOptions={{
                showClearButton: true,
                dataSource: customerGroups,
                displayExpr: "name",
                valueExpr: "id",
                placeholder: "Select customer group",
                searchEnabled: true,
                showDropDownButton: true,
              }}
            />
          </GroupItem>
          <ButtonItem
            horizontalAlignment='left'
            buttonOptions={{
              text: "Get report",
              useSubmitBehavior: true,
              stylingMode: "contained",
              type: "default",
            }}
          />
        </Form>
      </form>
    </div>
  );
};

export default FilterSelector;
